import React from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-599">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-600">
      <span className="block text-sm font-normal mb-1" data-id="element-601">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-602">Start de aanpak nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-603" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-604">
    <h3 className="text-[#5ce0d2] font-extrabold text-2xl mb-1 uppercase tracking-wide" data-id="element-605">
      Nu nog beschikbaar
    </h3>
    <h2 className="text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-606">Start vandaag</h2>

    <div className="mb-6" data-id="element-607">
      <img src="https://cdn.magicpatterns.com/uploads/vxv92giZwb84avmwkmhTZx/Scherm­afbeelding_2026-04-12_om_21.51.15.png" alt="Verlatingsangst Kernaanpak - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-608" />
    </div>

    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-609">Nu voor €27</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-610">(Bespaar €70)</div>

    <p className="text-sm text-gray-600 mb-6 leading-relaxed" data-id="element-611">
      Start met de Verlatingsangst Kernaanpak voor €27 in plaats van{' '}
      <span className="line-through" data-id="element-612">€97</span>. Per direct toegang. Start
      binnen de 3 minuten.
    </p>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-613">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-614" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-615">
      <p className="flex items-center justify-center gap-1" data-id="element-616">
        <Lock className="w-4 h-4" data-id="element-617" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-618">
        <ShieldCheck className="w-4 h-4" data-id="element-619" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
export function LiefdevolCommunicerenACPage() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-620">
      {/* 1. HEADER */}
      <div className="bg-[#e6f7f5] py-3 px-4" data-id="element-621">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-622">
          <div className="flex-1 hidden md:block" data-id="element-623"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-624" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-625">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-626">
              <Mail className="w-5 h-5 mr-2" data-id="element-627" />
              Hulp nodig? Email mij{' '}
              <span className="text-blue-600 ml-1 underline" data-id="element-628">HIER.</span>
            </a>
          </div>
        </div>
      </div>

      {/* 2. BLACK BANNER */}
      <div className="bg-black text-white text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-629">
        Voor baasjes die hun hond willen bevrijden van zijn verlatingsangst (en
        zichzelf ook)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-630">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-631">
          Oefenen is niet genoeg: Hoe je de echte oorzaak van verlatingsangst in
          3 stappen oplost
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-632">
          Zodat je hond zonder stress alleen thuis kan blijven, jij je vrijheid
          terugkrijgt, en je nooit meer bang hoeft te zijn dat je buren klagen.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-633">
          <div className="md:col-span-8" data-id="element-634">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-635">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-636">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-637"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-638">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-639">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-640">
                Wat is de nieuwe Verlatingsangst Kernaanpak?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-641">
                <p data-id="element-642">
                  De Verlatingsangst Kernmethode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de echte oorzaak van de spanning
                  van hun hond te herkennen, te begrijpen en blijvend op te
                  lossen.
                </p>
                <p data-id="element-643">
                  We laten je precies zien waardoor de spanning bij jouw hond
                  ontstaat en hoe je op basis daarvan een gericht trainingsplan
                  maakt dat de verlatingsangst bij het onderliggende probleem
                  aanpakt.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-644">
                  Zodat je dit niet tijdelijk, maar echt voorgoed oplost.
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-645">
            <PricingCard data-id="element-646" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-647">
        {/* 6. VOOR WIE WERKT DIT */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-648">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-649">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-650">
            Voor alle baasjes die honden met verlatingsangst die in paniek raken
            als hun baasje ze thuis achter laat:
          </p>
          <ul className="space-y-4" data-id="element-651">
            {['Het maakt niet uit als je nog nooit eerder met je hond hebt getraind.', 'De methode is eenvoudig en praktisch, zodat iedereen ermee aan de slag kan.', 'Geschikt voor honden van alle leeftijden en alle formaten.', 'Werkt ook bij speciale honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-652">
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-653" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-654">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-655">
          Met de Verlatingsangst Kernmethode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-656">
          <p data-id="element-657">
            ...zal je het blaffen, piepen, huilen en slopen van je hond als jij
            vertrekt in drie stappen verminderen door het onderliggende probleem
            op te lossen dat er nu voor zorgt dat hij terugvalt.
          </p>
          <p data-id="element-658">Waardoor hij niet zal terugvallen en het oefenen sneller gaat.</p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-659">
            Geen gevoel dat je keihard samen oefent maar nergens komt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-660">
          <img src="https://cdn.magicpatterns.com/uploads/vZLarCb4ynRSjgCisN7z8e/freepik_middelgrote-hond-in-een-g_2777443833.png" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-661" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-662">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-663">
            Signalen dat je hond verlatingsangst heeft
          </h3>
          <ul className="space-y-4" data-id="element-664">
            {['Piept, blaft of krijgt spanning als jij wilt vertrekken', 'Stopt niet als je eenmaal van huis bent', 'In huis plassen of poepen terwijl hij zindelijk is', 'Slopen, krabben of bijten aan meubels of deuren', 'Andere signalen van spanning als je van huis weg gaat'].map((item, i) => <li key={i} className="flex items-start" data-id="element-665">
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-666" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-667">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-668">
        <div className="max-w-4xl mx-auto px-4" data-id="element-669">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-670">
            <div data-id="element-671">
              <h2 className="text-3xl font-black text-[#1a2b4a] mb-4" data-id="element-672">
                Start vandaag
              </h2>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-673">
                Nu voor €27
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-674">
                (Bespaar €70)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-675">
                Start met de Verlatingsangst Kernaanpak voor €27 in plaats van{' '}
                <span className="line-through" data-id="element-676">€97</span>. Per direct toegang.
                Start binnen de 3 minuten.
              </p>
            </div>
            <div data-id="element-677">
              <CTAButton data-id="element-678" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-679">
                <p className="flex items-center justify-center gap-1" data-id="element-680">
                  <Lock className="w-4 h-4" data-id="element-681" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-682">
                  <ShieldCheck className="w-4 h-4" data-id="element-683" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-684">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-685">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-686">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-687">
              Wat is de nieuwe Verlatingsangst Kernaanpak?
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-688">
              <p data-id="element-689">
                Oefenen heeft pas zin als je het onderliggende probleem eerst
                oplost.
              </p>
              <p data-id="element-690">
                Doe je dat niet, dan komt dat kernprobleem vroeg of laat weer
                naar boven. En dan leert je hond opnieuw dat er vervelende
                dingen gebeuren als hij alleen is.
              </p>
              <p data-id="element-691">
                Sommige onderliggende kernproblemen komen snel en vaak omhoog,
                waardoor je met oefenen niet verder komt dan een paar minuten.
              </p>
              <p data-id="element-692">
                Andere kernproblemen zijn er minder vaak. Waardoor het na
                maanden oefenen lijkt te lukken om je hond 20 minuten alleen te
                laten, maar dan gebeurt er iets en ben je weer helemaal terug
                bij af.
              </p>
              <p className="font-medium" data-id="element-693">
                Daarom moet je eerst het onderliggende probleem oplossen. Dit is
                hoe het werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-694">
              <img src="https://cdn.magicpatterns.com/uploads/gZydPdwYJ47daE8nNYhLdq/9b6d1fe9789894c2655050948709230b.png" alt="Oude Aanpak vs De Nieuwe Verlatingsangst Kernaanpak" className="w-full h-auto object-contain rounded-lg" data-id="element-695" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-696">
              Kernprobleem oplossen in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-697">
              {[{
              title: 'Stap 1: Diagnose',
              text: 'De eerste stap is begrijpen welke van de vijf onderliggende kernproblemen er bij jouw hond spelen. En hiervoor moet je een diagnose doen.'
            }, {
              title: 'Stap 2: Behandelplan',
              text: 'De tweede stap is om het kernprobleem dat de echte oorzaak is van zijn verlatingsangst aan te pakken via een behandelplan dat jij als baasje zelfstandig kan uitvoeren. Vaak duurt dit twee weken waarin je dagelijks wat kleine oefeningen doet die zich richten op het kernprobleem.'
            }, {
              title: 'Stap 3: Oefenen',
              text: 'En als je zeker weet dat hij er klaar voor is… Dan ga je als derde stap oefenen. Simpel. Door deze voorbereiding maak je tijdens het oefenen grotere stappen met veel minder risico op een terugval. Het echte probleem heb je namelijk opgelost en je hoeft nog alleen het bestaande patroon te doorbreken.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-698">
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-699">
                    {i + 1}
                  </div>
                  <div data-id="element-700">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-701">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-702">
              Op deze manier kan zelfs een hond die al in paniek schiet als jij
              van de bank op staat leren om stressvrij alleen thuis te blijven
              zodat jij even kan sporten, een boodschap kan doen, of iets anders
              wat voor de meeste mensen gewoon heel normaal is.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-703">
              Zonder gepiep, geblaf of gehuil.
            </p>

            <div className="mb-16 rounded-xl overflow-hidden shadow-lg" data-id="element-704">
              <img src="https://cdn.magicpatterns.com/uploads/c5dwivjBuf94wiUeGKtu3j/freepik_man-en-vrouw-van-rond-de-_2777480988.png" alt="Man en vrouw verlaten ontspannen hun huis met hond op de achtergrond" className="w-full h-auto object-cover" data-id="element-705" />
            </div>

            {/* 12. ICEBERG */}
            <div className="bg-[#1a2b4a] text-white rounded-2xl p-8 md:p-12 mb-16 shadow-2xl" data-id="element-706">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-8 text-center" data-id="element-707">
                Waarom deze methode werkt juist als nog niks gewerkt heeft
              </h2>
              <div className="flex items-center gap-5 mb-10 max-w-2xl mx-auto" data-id="element-708">
                <blockquote className="text-xl italic text-gray-300 border-l-4 border-[#5ce0d2] pl-4 flex-1" data-id="element-709">
                  "De geest is als een ijsberg. Slechts een klein deel is
                  zichtbaar boven het water." - Sigmund Freud
                </blockquote>
                <img src="https://cdn.magicpatterns.com/uploads/qmwWHyfVMxLgrevSP4D47H/sigmund.jpg" alt="Sigmund Freud" className="w-20 h-20 rounded-full object-cover flex-shrink-0 border-2 border-[#5ce0d2]" data-id="element-710" />
              </div>

              <div className="space-y-6 text-gray-200 text-lg leading-relaxed" data-id="element-711">
                <p data-id="element-712">
                  Het huilen, blaffen of piepen als jij van huis gaat is maar
                  een klein deel van wat er bij je hond gebeurd. Hij laat dit
                  gedrag zien omdat hij stress ervaart. Deze stress is een
                  automatische lichamelijke reflex. Deze reflex wordt
                  veroorzaakt omdat ergens diep in zijn onderbewuste brein iets
                  verkeerd gaat. Dit zien we niet direct maar deze processen
                  bepalen al zijn emoties en gedragingen.
                </p>
                <p data-id="element-713">
                  Je kan het eigenlijk zien als een ijsberg in de zee. Het
                  blaffen, piepen en gedrag dat wij "verlatingsangst" noemen is
                  wat je ziet. Dit is de <strong data-id="element-714">10% van de ijsberg</strong> die
                  boven water drijft.
                </p>
                <p data-id="element-715">
                  Dan zijn er zijn emoties en de spanning die hij ervaart. Als
                  je goed kijkt kan je dit herkennen. Dit is het deel onderwater
                  wat je nog kan zien. Dit is nog eens <strong data-id="element-716">30%</strong>.
                </p>
                <p data-id="element-717">
                  Dan ligt er diep onderwater nog een heel groot deel van de
                  ijsberg. Dit zijn de onbewuste processen die voortkomen uit de
                  diepgewortelde behoeftes van je hond. Bij verlatingsangst is
                  er hier een kernprobleem. Dit is nog eens <strong data-id="element-718">60%</strong>{' '}
                  van wat er eigenlijk aan de hand is.
                </p>
                <p className="font-bold text-white" data-id="element-719">
                  Als je verlatingsangst wilt aanpakken dan moet je aan de slag
                  met de hele ijsberg. Niet alleen met het zichtbare gedrag.
                </p>
                <p data-id="element-720">
                  Dus als je het kernprobleem niet oplost dan heeft oefenen maar
                  10% van het effect dat je wilt. Dat is waarom direct oefenen
                  zo langzaam gaat en je hond snel terugvalt in oud gedrag. Het
                  is dan alsof je de ijsberg even onder water hebt geduwd en hij
                  weer boven komt. Dit is wat andere methodes verkeerd doen. Ze
                  beginnen direct, of veel te snel met oefenen. Daarom gaat het
                  langzaam, blijft je hond terugvallen in gedrag en vindt er
                  geen echte verandering plaats.
                </p>
                <div className="mt-8 rounded-xl overflow-hidden" data-id="element-721">
                  <img src="https://cdn.magicpatterns.com/uploads/dp1MNNz2c1oFtFSZvJECoy/7db3c11805f8570f0b6c849247d8d1b4.jpg" alt="Verlatingsangst IJsberg Theorie" className="w-full h-auto object-contain rounded-lg" data-id="element-722" />
                </div>
              </div>
            </div>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-723">
              Zo pas je de Verlatingsangst Kernaanpak vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-724">
              De Verlatingsangst Kernaanpak Methode wordt alleen door onze
              coaches gebruikt tijdens onze behandeltrajecten. Niemand in
              Nederland werkt nog op deze manier. Maar wij vinden dat ieder
              hondenbaasje dat worstelt met de verlatingsangst van zijn hond de
              kans zou moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-725">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we in drie compacte lessen ieder van de drie
              essentiële stappen in deze aanpak.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-726">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de verschillende kernproblemen van verlatingsangst en hoe je zelf een diagnose doet zodat je zeker weet dat je niet werkt aan het verkeerde probleem.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je ieder van de kernproblemen oplost zodat je hond klaar is om te oefenen en met zekerheid door kan naar stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe je effectief moet oefenen met je hond zodat je zo snel mogelijk resultaat hebt.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-727">
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-728">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-729">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-730">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-731">
            <div className="sticky top-8" data-id="element-732">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-733">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-734">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-735">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-736">
                    <img src="https://cdn.magicpatterns.com/uploads/bPH8swctNa91LRo7t5rtnE/Verlatingangst_kernmethode_bonus_(3).png" alt="Verlatingsangst Kern Aanpak - Stappenplan" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-737" />
                    <div data-id="element-738">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-739">
                        VERLATINGSANGST KERN AANPAK - STAPPENPLAN
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-740">
                        Gedetailleerde uitleg van hoe je de echte oorzaak van
                        verlatingsangst in 3 stappen oplost zonder dat hij
                        terugvalt in oud gedrag
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-741">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-742">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-743" />
                    <div data-id="element-744">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-745">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-746">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-747">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Gezonde hond in 12 weken training" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-748" />
                    <div data-id="element-749">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-750">
                        Gezonde hond in 12 weken training
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-751">
                        Methode om met natuurlijk hondenvoer en supplementen de
                        gezondheid van jouw hond in 12 weken te herstellen
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-752">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Stoomcursus Stressless Dog Methodes" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-753" />
                    <div data-id="element-754">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-755">
                        Stoomcursus Stressless Dog Methodes
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-756">
                        Mini training over verschillende Stressless Dogs
                        Methodes, technieken en vaardigheden voor stressvrij
                        wandelen, hondencommunicatie, en meer.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-757">
                    RESULTATEN VAN DE KERNAANPAK
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-758">
                    <div style={{
                    padding: '56.25% 0 0 0',
                    position: 'relative'
                  }} data-id="element-759">
                      <iframe src="https://player.vimeo.com/video/1158372685?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-760"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-761">
        <div className="max-w-6xl mx-auto px-4" data-id="element-762">
          {/* Section headline */}
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-763">
            RESULTATEN VAN DE KERNAANPAK
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-764">
            Dit is hoe ik honden met verlatingsangst help om stressvrij alleen
            thuis te blijven door eerst het onderliggende kernprobleem aan te
            pakken, dit maakt de verdere aanpak veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-765">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Verlatingsangst Kernaanpak
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-766">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-767">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-768">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-769">
                  <p className="font-bold" data-id="element-770">
                    Beste toekomstige Verlatingsangst Kernaanpakker
                  </p>
                  <p data-id="element-771">
                    <strong data-id="element-772">Van:</strong> Amee Buijs
                  </p>
                  <p data-id="element-773">
                    <strong data-id="element-774">Re:</strong> De enige manier om verlatingsangst écht
                    op te lossen, is door je op het kernprobleem te focussen (en
                    niet op het oefenen).
                  </p>
                  <p data-id="element-775">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos oefenen waarmee je verlatingsangst sneller kunt
                    oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-776">En dat is niet gek.</p>
                  <p data-id="element-777">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: oefenschema's, sleutels rammelen, je
                    hond laten uitblaffen, of afleiden bij vertrek.
                  </p>
                  <p data-id="element-778">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-779">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-780">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-781">
                    <strong data-id="element-782">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Elke verandering vraagt om inzet en doorzettingsvermogen.
                    Als je daar niet toe bereid bent, dan is deze methode
                    misschien niet voor jou. Met dat gezegd, laat me je laten
                    zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-783">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-784">
                    Dit is dezelfde Verlatingsangst-Kernaanpak model die
                    honderden hondeneigenaren nu gebruiken om de paniek bij hun
                    hond écht op te lossen.
                  </p>
                  <p data-id="element-785">
                    Hierdoor krijgen zij hun spontane vrijheid terug, sneller
                    dan ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-786">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-787">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-788">
                    Het is een fundamenteel andere manier van denken over
                    verlatingsangst. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-789">
                    <li data-id="element-790">
                      Eindeloze, korte oefensessies die nergens toe leiden.
                    </li>
                    <li data-id="element-791">Je hond negeren of laten blaffen tot hij stopt.</li>
                    <li data-id="element-792">Trucjes om je hond af te leiden bij vertrek.</li>
                    <li data-id="element-793">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-794">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met een diagnose om het échte kernprobleem te
                    vinden.
                  </p>
                  <p data-id="element-795">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-796">
                    Hoe ik dit ontdekte: De "Cirkel van Wanhoop" bij mijn
                    klanten
                  </h3>
                  <p data-id="element-797">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Cirkel van Wanhoop":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-798">
                    <p data-id="element-799">
                      <strong data-id="element-800">Stap 1:</strong> Ze volgden online oefenschema's
                      en begonnen met 30 seconden de deur uit.
                    </p>
                    <p data-id="element-801">
                      <strong data-id="element-802">Stap 2:</strong> De hond blafte, dus ze gingen te
                      snel. Terug naar 10 seconden.
                    </p>
                    <p data-id="element-803">
                      <strong data-id="element-804">Stap 3:</strong> Na een week kon de hond een
                      minuut alleen zijn. Een klein succes!
                    </p>
                    <p data-id="element-805">
                      <strong data-id="element-806">Stap 4:</strong> Ze probeerden vijf minuten, en de
                      hond raakte volledig in paniek.
                    </p>
                    <p data-id="element-807">
                      <strong data-id="element-808">Stap 5:</strong> De buren klaagden. Ze voelden
                      zich slechte eigenaren.
                    </p>
                    <p data-id="element-809">
                      <strong data-id="element-810">Stap 6:</strong> Ze gaven het op en regelden weer
                      een oppas voor elke boodschap.
                    </p>
                    <p data-id="element-811">
                      <strong data-id="element-812">Stap 7:</strong> Na een paar weken frustratie
                      begonnen ze weer bij Stap 1.
                    </p>
                  </div>
                  <p data-id="element-813">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-814">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen.
                  </p>
                  <p data-id="element-815">
                    Ik stond op het punt om te geloven dat verlatingsangst bij
                    sommige honden gewoon onoplosbaar was.
                  </p>
                  <p data-id="element-816">
                    Maar voordat ik dit opgaf, wilde ik nog één ding proberen.
                    Iets wat, als het zou werken, alles zou veranderen.
                  </p>
                  <p className="font-bold" data-id="element-817">En het werkte.</p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-818">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee Buijs" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-819" />
                    <div data-id="element-820">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-821">
                        Mijn naam is Amee, en ik zag jouw frustratie bij al mijn
                        klanten.
                      </h3>
                      <div className="space-y-4" data-id="element-822">
                        <p data-id="element-823">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde en zorg in pure paniek
                          raakten zodra de deur dichtging.
                        </p>
                        <p data-id="element-824">
                          Eigenaren, vooral vrouwen van 50+, die hun hele leven
                          om hun hond heen planden.
                        </p>
                        <p data-id="element-825">
                          Geen spontaan kopje koffie met een vriendin, niet meer
                          naar yoga, altijd die knoop in je maag als je de deur
                          uit moest.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-826">
                    Ze voelden zich gevangen in hun eigen huis, schuldig
                    tegenover hun hond, en bezwaard naar de omgeving die altijd
                    moest bijspringen.
                  </p>
                  <p data-id="element-827">
                    En ik zag dat mijn standaard aanpak hen niet echt hielp.
                  </p>
                  <p data-id="element-828">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen de verlatingsangst niet opgelost
                    met de standaard aanpak.
                  </p>
                  <p data-id="element-829">
                    Pas toen we aan de slag gingen met een andere angst die hij
                    had – iets in zijn omgeving – gebeurde er iets magisch. De
                    verlatingsangst verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-830">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-831">
                    Verlatingsangst was niet het probleem; het was een symptoom.
                  </p>
                  <p data-id="element-832">En dat veranderde alles in hoe ik werkte.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-833">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-834">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "symptoombestrijders" en je hebt ons van Stressless
                    Dogs, wij zijn de "kernaanpakkers".
                  </p>
                  <p data-id="element-835">
                    Maar jarenlang was ik ook een symptoombestrijder. Ik
                    probeerde mijn klanten te helpen door het blaffen, piepen en
                    slopen af te leren.
                  </p>
                  <p data-id="element-836">
                    Maar het probleem is niet het gedrag zelf. Het probleem is
                    de onderliggende emotie die het gedrag veroorzaakt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-837">
                    Het gevaarlijkste advies dat je kunt krijgen, is "gewoon
                    oefenen en laten wennen".
                  </p>
                  <p data-id="element-838">
                    Waarom? Omdat je daarmee de onderliggende stress negeert.
                  </p>
                  <p data-id="element-839">
                    Soms verergert het de situatie zelfs, waardoor de stress
                    overslaat op andere aspecten van het leven van je hond. Je
                    bent de paniek aan het managen, niet aan het oplossen.
                  </p>
                  <p data-id="element-840">
                    De oplossing gaat tegen je gevoel in: stop met focussen op
                    het oefenen van alleen zijn. In plaats daarvan richten we
                    ons op de wortel van het probleem.
                  </p>
                  <p data-id="element-841">
                    Is het verveling? Trauma? Omgevingsangst? Of een van de
                    andere vijf kernproblemen?
                  </p>
                  <p className="font-bold" data-id="element-842">
                    Zodra je de diagnose stelt en het kernprobleem aanpakt,
                    wordt het oefenen verrassend eenvoudig en effectief.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-843">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-844">
                    {[{
                    title: 'Stap 1: De Diagnose',
                    text: 'Leer de verschillende oorzaken van verlatingsangst en hoe je ontdekt welke oorzaak bij jouw hond speelt.'
                  }, {
                    title: 'Stap 2: De Kernaanpak',
                    text: 'Krijg de tools om de specifieke kernproblemen op te lossen en een sterke, veerkrachtige basis te leggen voor je hond.'
                  }, {
                    title: 'Stap 3: Het Oefenen',
                    text: 'Leer hoe je stressvrij en effectief kunt oefenen, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-845">
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-846" />
                        <div data-id="element-847">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-848">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-849">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-850">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-851">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-852">
                    Deze methode is <strong data-id="element-853">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-854">
                    Deze methode is <strong data-id="element-855">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-856">
                    Als je klaar bent om de cirkel van wanhoop te doorbreken en
                    je vrijheid terug te krijgen, dan is dit het moment. Stop
                    met symptoombestrijding en start met de kernaanpak.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-857">
                    <img src="https://cdn.magicpatterns.com/uploads/bEbEj36tRb2txwLv3vaAfN/freepik_man-en-vrouw-van-rond-de-_2777484675.png" alt="Man en vrouw kijken naar ontspannen hond" className="w-full h-auto object-cover" data-id="element-858" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-859">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-860">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-861">
                  <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Verlatingsangst Kernaanpak Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-862" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-863">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-864">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-865">
                    <div className="flex items-start gap-3" data-id="element-866">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-867" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-868">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-869">
                      Dit leer je in Les 1
                    </p>
                    {['Hoezo oefenen met alleen thuis zijn geen nut heeft als je niet eerst het onderliggende probleem aanpakt', 'Welke onderliggende kernproblemen er zijn bij verlatingsangst en welke er voor jouw hond waarschijnlijk speelt', 'Hoe je zelf een diagnose doet zodat je weet waarmee je eerst aan de slag moet'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-870">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-871" />
                        <span className="text-sm text-gray-700" data-id="element-872">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-873">
                      Dit leer je in Les 2
                    </p>
                    {['Hoe je een effectief behandelplan maakt voor jouw hond zodat je in de juiste volgorde aan de slag gaat', 'Wat je wel, en wat je juist niet moet oefenen zodat je geen tijd en energie stopt in de verkeerde dingen', 'Voorbeeld casus van hond Lemmy en hoe deze van totaal niet alleen kon zijn na 3 weken 3 uur alleen kon zijn met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe ook die hun verlatingsangst in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-874">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-875" />
                        <span className="text-sm text-gray-700" data-id="element-876">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-877">
                      Dit leer je in Les 3
                    </p>
                    {['Effectief oefenplan zodat je op de juiste manier zijn tijd alleen opbouwt', 'Drie voorbeeld behandel- en oefenplannen met verschillende onderliggende problemen'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-878">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-879" />
                        <span className="text-sm text-gray-700" data-id="element-880">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-881">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Herkennen van blafsoorten zodat je aan het type geblaf kan horen waarom hij blaft (angst, eenzaamheid, verveling, etc)', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit en het wel of geen goed moment is om te oefenen', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-882">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-883" />
                        <span className="text-sm text-gray-700" data-id="element-884">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-885">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-886">
                    Start met de Verlatingsangst Kernaanpak Methode
                  </div>
                  <div className="p-5 text-center" data-id="element-887">
                    <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Verlatingsangst Kernaanpak Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-888" />
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-889">
                      Slechts €27
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-890">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-891">
                      Start met de methode voor €27. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-892">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-893">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-894">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-895">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-896">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-897">
                    <img src="https://cdn.magicpatterns.com/uploads/qadgiKJVMEENSSwLSHdnib/Scherm­afbeelding_2026-04-13_om_16.11.42.png" alt="Review Marijke" className="w-full h-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-898" />
                    <img src="https://cdn.magicpatterns.com/uploads/pu6bXE2Mf7TwUeQJ5i8sft/Scherm­afbeelding_2026-04-13_om_16.11.31.png" alt="Review Lut Matthys" className="w-full h-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-899" />
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-900">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-901">
                    Start met de Verlatingsangst Kernaanpak Training
                  </div>
                  <div className="p-5 text-center" data-id="element-902">
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-903">
                      Slechts €27 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-904">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-905">
                      Start met de methode voor €27. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-906">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-907">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-908">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-909">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-910">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Gezonde hond in 12 weken',
                    desc: 'Methode om met natuurlijk hondenvoer en supplementen de gezondheid van jouw hond in 12 weken te herstellen'
                  }, {
                    title: 'Stoomcursus Stressless Dog Methodes',
                    desc: 'Mini training over verschillende Stressless Dogs Methodes, technieken en vaardigheden voor stressvrij wandelen, hondencommunicatie, en meer.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-911">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-912" />
                        <div data-id="element-913">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-914">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-915">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-916">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-917">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-918">
                    {['1158442858', '1158442995', '1158442918', '1158443130'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-919">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-video" title={`Testimonial ${id}`} data-id="element-920"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-921">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-922">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-923">
                    Start nu met de Verlatingsangst Kernaanpak
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-924">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-925">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-926" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-927">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-928">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-929">
            <p data-id="element-930">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €27 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-931">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-932">
              Ik geef je een 365 dagen om de Verlatingsangst Kernaanpak Training
              te bekijken en toe te passen.
            </p>
            <p data-id="element-933">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €27 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-934">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-935">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-936">
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-937">
            Vandaag voor €27
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-938">
            (Bespaar €70)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/cn6aNStyPs26sEQni2fyTV/Ontwerp_zonder_titel_(21).jpg" alt="Verlatingsangst Kernaanpak Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-939" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-940">
            Start met de Verlatingsangst Kernaanpak voor{' '}
            <span className="line-through" data-id="element-941">€97</span> slechts €27! Direct
            toegang tot online lesmateriaal. Neem de eerste stap in 2 minuten.
          </p>
          <div className="max-w-md mx-auto" data-id="element-942">
            <CTAButton data-id="element-943" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-944">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-945">
        <div className="max-w-6xl mx-auto px-4" data-id="element-946">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-947">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-948">
            {[{
            title: 'Verlatingsangst Kernaanpak Methode',
            desc: 'Volledige training in hoe je de Verlatingsangst Kernaanpak inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/d7mvv6jB1XyRHfPv1QLUbd/Verlatingangst_kernmethode_bonus_(2).png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Stoomcursus Stressless Dog Methodes',
            desc: 'Mini training over verschillende Stressless Dogs Methodes, technieken en vaardigheden voor stressvrij wandelen, hondencommunicatie, en meer.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Gezonde hond in 12 weken training',
            desc: 'Methode om met natuurlijk hondenvoer en supplementen de gezondheid van jouw hond in 12 weken te herstellen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-949">
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-950">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-951">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-952">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-953" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-954">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-955">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-956">
        <div className="max-w-md mx-auto" data-id="element-957">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-958">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-959">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-960">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-961">
          <div className="flex-1 text-center md:text-left" data-id="element-962">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-963">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-964">
              <strong data-id="element-965">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-966">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-967">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-968" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-969">
        <div className="max-w-5xl mx-auto px-4" data-id="element-970">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-971">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-972">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vindt je drie uitgebreide lessen waarin je alles leert over de verlatingsangst kernaanpak.'
          }, {
            q: 'Wat is de Verlatingsangst Kernaanpak?',
            a: 'Dit is een nieuwe methode waarin je het onderliggende kernprobleem van verlatingsangst aanpakt in plaats van je alleen maar te richten op oefenen. Wij gebruiken deze methode om jaarlijks bij honderden honden verlatingsangst bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: "Alles wat je kan vinden gaat alleen maar over oefen schema's en verschillende methodes van oefenen. Met deze methode kijk je naar het type verlatingsangst dat je hond heeft, pak je dat bij de kern aan en ga je daarna pas oefenen. Op deze manier heb je sneller, beter en blijvend resultaat."
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de verlatingsangst van hun hond nu voor eens en altijd willen oplossen en dit op een empatische manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-973">
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-974">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-975" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-976">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-977">
        <div className="max-w-md mx-auto" data-id="element-978">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-979">
            Start met deze methode
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-980">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-981">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-982">
          <p className="font-bold text-white mb-8" data-id="element-983">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-984">
            <p className="font-bold text-white" data-id="element-985">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-986">
              Start met de training.
            </a>
          </div>

          <p className="text-justify" data-id="element-987">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-988">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-989">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-990">
            <img src="https://cdn.magicpatterns.com/uploads/oxTbd4Fk83NKokLatjZK4s/Verlatingangst_kernmethode_bonus_(4).png" alt="Verlatingsangst Kernaanpak Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-991" />
            <img src="https://cdn.magicpatterns.com/uploads/cRmnco8rsPRXFAp45VMFKA/Ontwerp_zonder_titel_(70).png" alt="Verlatingsangst Kernaanpak" className="w-16 md:w-24 h-auto object-contain" data-id="element-992" />
            <div data-id="element-993">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-994">
                Verlatingsangst Kernaanpak
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-995">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-996">
                  €97
                </span>
                €27
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-997">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}